import type { CSSProperties } from 'react';
import { useState } from 'react';

interface FieldProps {
  as?: 'input' | 'textarea';
  type?: string;
  name?: string;
  required?: boolean;
  placeholder?: string;
  rows?: number;
  style?: CSSProperties;
  /** Extra style merged in while focused (translates the design's `style-focus`). */
  focusStyle?: CSSProperties;
}

/**
 * Input/textarea whose inline style gains `focusStyle` on focus — the React
 * equivalent of the design build's `style-focus` attribute.
 */
export default function Field({
  as = 'input',
  type = 'text',
  name,
  required,
  placeholder,
  rows,
  style,
  focusStyle,
}: FieldProps) {
  const [focused, setFocused] = useState(false);
  const merged = focused && focusStyle ? { ...style, ...focusStyle } : style;

  const handlers = {
    onFocus: () => setFocused(true),
    onBlur: () => setFocused(false),
  };

  if (as === 'textarea') {
    return (
      <textarea
        name={name}
        required={required}
        placeholder={placeholder}
        rows={rows}
        style={merged}
        {...handlers}
      />
    );
  }

  return (
    <input
      type={type}
      name={name}
      required={required}
      placeholder={placeholder}
      style={merged}
      {...handlers}
    />
  );
}
